import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import React from "react";
import * as yup from "yup";
import API from "@/api/serverCall";

interface EditPasswordDialogProps {
	openModal: boolean;
	handleModalClose: () => void;
}
type passwordInfoType = {
	oldPassword: string;
	newPassword: string;
};
const validationSchema = yup.object({
	oldPassword: yup.string().required("현재비밀번호를 입력해주세요"),
	newPassword: yup
		.string()
		.required("새로운 비밀번호를 입력해주세요")
		.matches(
			/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,20}$|^(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}$|^(?=.*[^a-zA-Z0-9])(?=.*[0-9]).{8,20}$/,
			"8~20자 사이, 영문(대소문자)+숫자+특수문자 중 2종류 이상을 조합하여 사용할 수 있습니다",
		),
});

const EditPasswordDialog: React.FC<EditPasswordDialogProps> = ({
	openModal,
	handleModalClose,
}) => {
	const { enqueueSnackbar } = useSnackbar();

	const formik = useFormik({
		initialValues: {
			oldPassword: "",
			newPassword: "",
			confirmPassword: "",
		},
		validationSchema,
		onSubmit: (values) => {
			if (values.confirmPassword === values.newPassword) {
				const requestData = {
					oldPassword: values.oldPassword,
					newPassword: values.newPassword,
				};
				editAppFunc(requestData);
			}
		},
	});

	const editAppFunc = ({ oldPassword, newPassword }: passwordInfoType) => {
		try {
			const requestData = {
				oldPassword,
				newPassword,
			};
			API.POST<string>({
				link: `/user/changePassword`, // 두잉랩서버 로그인토큰발급 api임
				body: requestData,
			})
				.then(() => {
					handleModalClose();
					enqueueSnackbar("비밀번호가 변경되었습니다", {
						variant: "info",
					});
					formik.resetForm();
				})
				.catch((error) => {
					if (error.response.status === 404) {
						enqueueSnackbar("현재 비밀번호가 일치하지 않습니다", {
							variant: "info",
						});
					} else {
						enqueueSnackbar("일시적 오류입니다", {
							variant: "info",
						});
					}
					formik.resetForm();
				});
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<Dialog onClose={handleModalClose} open={openModal} fullWidth={true}>
			<DialogTitle>비밀번호 변경</DialogTitle>
			<DialogContent>
				<form onSubmit={formik.handleSubmit}>
					<div style={{ marginTop: "3rem" }}>
						<span>현재비밀번호</span>
						<TextField
							id="oldPassword"
							name="oldPassword"
							variant="outlined"
							size="medium"
							type="password"
							fullWidth={true}
							value={formik.values.oldPassword}
							onChange={formik.handleChange}
							error={
								formik.touched.oldPassword &&
								Boolean(formik.errors.oldPassword)
							}
							helperText={
								formik.touched.oldPassword && formik.errors.oldPassword
							}
							sx={{ marginTop: "0.5rem" }}
						/>
					</div>
					<div style={{ marginTop: "1rem" }}>
						<span>새로운 비밀번호</span>

						<TextField
							id="newPassword"
							name="newPassword"
							variant="outlined"
							type="password"
							size="medium"
							fullWidth={true}
							value={formik.values.newPassword}
							onChange={formik.handleChange}
							error={
								formik.touched.newPassword &&
								Boolean(formik.errors.newPassword)
							}
							helperText={
								formik.touched.newPassword && formik.errors.newPassword
							}
							sx={{ marginTop: "0.5rem" }}
						/>
					</div>
					<div style={{ marginTop: "1rem" }}>
						<span>새로운 비밀번호 확인</span>
						<TextField
							id="confirmPassword"
							name="confirmPassword"
							variant="outlined"
							type="password"
							size="medium"
							fullWidth={true}
							sx={{ marginTop: "0.5rem" }}
							value={formik.values.confirmPassword}
							onChange={formik.handleChange}
							error={
								formik.touched.confirmPassword &&
								Boolean(formik.errors.confirmPassword)
							}
							helperText={
								formik.touched.confirmPassword &&
								formik.errors.confirmPassword
							}
						/>

						{formik.values.confirmPassword !== formik.values.newPassword && (
							<span
								style={{
									marginTop: "1rem",
									display: "block",
									color: "red",
									fontSize: "0.9rem",
								}}
							>
								비밀번호가 일치하지 않습니다
							</span>
						)}
					</div>
					<div
						style={{
							display: "flex",
							justifyContent: "flex-end",
							marginTop: "5rem",
						}}
					>
						<Button
							variant="outlined"
							sx={{
								color: "#747474",
								borderColor: "#CCCCCC",
								marginRight: "0.5rem",
							}}
							onClick={handleModalClose}
						>
							취소
						</Button>
						<Button
							variant="contained"
							sx={{ backgroundColor: "#2453F9", color: "white" }}
							type="submit"
						>
							변경
						</Button>
					</div>
				</form>
			</DialogContent>
		</Dialog>
	);
};
export default EditPasswordDialog;
